import store from '@/common/store/StoreCommon'

export function isLoggedIn () {
  const userState = store.state.user
  const userInfo = userState.userInfo
  if (!userInfo || !userInfo.userName) return false
  const certificate = userState.certificate !== undefined
    ? userState.certificate
    : userInfo.certificate
  return !!certificate
}

export function isLoginRoute (path) {
  const normalized = (path || '').replace(/\/$/, '') || '/'
  return normalized === '/srmLogin'
}

export function mergeOAuthQuery (route) {
  const query = { ...(route && route.query ? route.query : {}) }
  const merge = (queryString) => {
    if (!queryString) return
    const qs = queryString.startsWith('?') ? queryString.slice(1) : queryString
    qs.split('&').forEach((pair) => {
      if (!pair) return
      const [k, v] = pair.split('=')
      if (k && query[k] == null) query[k] = decodeURIComponent(v || '')
    })
  }
  if (typeof window !== 'undefined') {
    merge(window.location.search)
    const hash = window.location.hash || ''
    if (hash.indexOf('?') > -1) {
      merge(hash.substring(hash.indexOf('?') + 1))
    }
  }
  return query
}

export function srmLoginRedirect (route) {
  return { path: '/srmLogin', query: mergeOAuthQuery(route) }
}



// WEBPACK FOOTER //
// ./src/utils/authRoute.js